import { Link, useLocation } from "react-router-dom";
import logo from "@/assets/logo.webp";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const navItems = [
  { label: "דף הבית", href: "/" },
  { label: "חתימות דיגיטליות", href: "/digital-signatures" },
  { label: "פורטל דיירים", href: "/tenant-portal" },
  { label: "מסלולים", href: "/pricing" },
  { label: "בלוג", href: "/blog" },
  { label: "אודות", href: "/about" },
  { label: "צור קשר", href: "/contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/80 backdrop-blur-lg">
      {/* Desktop: CSS Grid with 3 equal-weight columns for perfect centering */}
      <div className="container hidden lg:grid h-20 grid-cols-[1fr_auto_1fr] items-center gap-4">
        {/* Right column (RTL start) — Logo */}
        <div className="flex items-center justify-start">
          <Link to="/" className="flex-shrink-0">
            <img
              src={logo}
              alt="OneStep"
              className="h-20 w-auto object-contain"
              width="1780"
              height="940"
              fetchPriority="high"
            />
          </Link>
        </div>

        {/* Center column — Navigation */}
        <nav className="flex items-center gap-1" aria-label="ניווט ראשי">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === item.href
                  ? "text-accent"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Left column (RTL end) — CTA buttons */}
        <div className="flex items-center justify-end gap-2">
          <a
            href="https://app.onestep.co.il/portal"
            rel="noopener noreferrer"
            className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors whitespace-nowrap"
          >
            כניסה לדיירים
          </a>
          <a
            href="https://app.onestep.co.il/login"
            rel="noopener noreferrer"
            className="gradient-accent px-5 py-2.5 rounded-lg text-sm font-semibold text-accent-foreground shadow-sm hover:opacity-90 transition-opacity whitespace-nowrap"
          >
            כניסה לצוות
          </a>
        </div>
      </div>

      {/* Mobile: simple flex row with logo + hamburger */}
      <div className="container flex lg:hidden h-16 items-center justify-between">
        <Link to="/" className="flex-shrink-0">
          <img
            src={logo}
            alt="OneStep"
            className="h-10 w-auto object-contain"
            width="1780"
            height="940"
            fetchPriority="high"
          />
        </Link>
        <button
          onClick={() => setOpen(!open)}
          className="p-2 text-foreground"
          aria-label={open ? "סגור תפריט" : "פתח תפריט"}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-border bg-background animate-fade-in">
          <nav className="container flex flex-col gap-1 py-4" aria-label="ניווט ראשי">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setOpen(false)}
                className={`px-4 py-3 rounded-md text-sm font-medium ${
                  location.pathname === item.href
                    ? "text-accent bg-accent/10"
                    : "text-muted-foreground"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-3 flex flex-col gap-2 px-4">
              <a
                href="https://app.onestep.co.il/portal"
                rel="noopener noreferrer"
                className="text-center py-2.5 rounded-lg border border-border text-sm font-medium"
              >
                כניסה לדיירים
              </a>
              <a
                href="https://app.onestep.co.il/login"
                rel="noopener noreferrer"
                className="gradient-accent text-center py-2.5 rounded-lg text-sm font-semibold text-accent-foreground"
              >
                כניסה לצוות
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
